var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('iframe',{ref:"formurl",staticClass:"embed-responsive-item",attrs:{"frameborder":"0","src":"https://calc.pinphon.com/#/information/performance"}})])}
var staticRenderFns = []

export { render, staticRenderFns }